import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Analysis from "./Analysis";
import Hazard from "./Hazard";
import Location from "./Location";
import Year from "./Year";
import FilterListIcon from "@mui/icons-material/FilterList";
import { clearFilters } from "../../../actions/filters";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const PREFIX = 'Filters';

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  headerTitle: `${PREFIX}-headerTitle`,
  icon: `${PREFIX}-icon`,
  title: `${PREFIX}-title`,
  clear: `${PREFIX}-clear`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    marginRight: "4em",
  },

  [`& .${classes.header}`]: {
    height: "3em",
    display: "flex",
    marginBottom: "1.5em",
    alignItems: "center",
    justifyContent: "space-between",
  },

  [`& .${classes.headerTitle}`]: {
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.icon}`]: {
    margin: "-0.1em 1em",
  },

  [`& .${classes.title}`]: {
    fontWeight: "bold",
  },

  [`& .${classes.clear}`]: {
	color: "rgba(0, 0, 0, 0.87)",
    margin: "-0.4em 0 0 2em",
    fontSize: "0.7rem",
    border: "1px solid #d3d3d3 !important",
    borderRadius: "50px",
    padding: "0.1em 0.5em",
    background: "#fff",
    "&:hover": {
      background: "#f9f9f9",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  }
}));

const Filters = ({ clearFilters, analysisType }) => {

  const [showYear, setShowYear] = useState(true);

  const clear = () => {
    clearFilters();
  };

  useEffect(() => {
    if (
      analysisType.historic ||
      Object.values(analysisType).filter((type) => type === false).length ===
        Object.keys(analysisType).length
    ) {
      setShowYear(true);
    } else {
      setShowYear(false);
    }
  }, [analysisType]);

  return (
    <Root id="filters" className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headerTitle}>
          <span className={classes.title}>Filters</span>
          <FilterListIcon className={classes.icon} />
        </div>
        <Button
          className={classes.clear}
          onClick={clear}
          aria-label="clear analysis filters"
        >
          Clear Filters
        </Button>
      </div>
      <div className={classes.filters}>
        <Location />
        <Hazard />
        <Analysis />
        {showYear ? <Year /> : ""}
      </div>
    </Root>
  );
};

Filters.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  analysisType: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  analysisType: state.filters.analysisType,
});

export default connect(mapStateToProps, { clearFilters })(Filters);
